module.exports = __webpack_public_path__ + "img/galeria-especie-prioritaria-2.7c12db9b.jpg";